import script from "./ProposalList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalList.vue?vue&type=script&setup=true&lang=js"

import "./ProposalList.vue?vue&type=style&index=0&id=3bc9b6a8&lang=css"

const __exports__ = script;

export default __exports__